import { lazy } from "react";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { historikYear } from "@/hooks/useHistoricalPrices";

const ElpriserHistorikAr = lazy(() => import("@/pages/elpriser/HistorikAr"));

export const Route = createFileRoute("/elpriser/historik/$yearSlug/")({
  // Okänt år: riktig 404 (sidan skickade annars vidare först i webbläsaren).
  beforeLoad: ({ params }) => {
    if (!historikYear(params.yearSlug)) throw notFound();
  },
  head: ({ params }) => {
    const year = String(params.yearSlug).replace(/^elpriser-/, "");
    return seoHead(`/elpriser/historik/${params.yearSlug}`, {
      description: `Historiska elpriser ${year}: månadsmedelpris per elområde (SE1–SE4), dyraste och billigaste månaden samt utvecklingen över året.`,
    });
  },
  component: () => <ElpriserHistorikAr />,
});
